/**
 * Created by Bart Decorte
 * Date: 09/10/2021
 * Time: 13:14
 */

export default class FileInfo {
  constructor(rootEl, { offset }) {
    this.rootEl = rootEl;
    this.offset = offset;
  }

  namePrefix() {
    return this.rootEl.dataset.namePrefix;
  }

  removeFileInfo(index) {
    ['path', 'originalName', 'mimeType'].forEach(component => {
       this.detachFileInfoComponent(index, component);
    });
  }

  renderFilesMeta(filesMeta) {
    this.removeFileInfo();
    for (let i = 0; i < filesMeta.length; i++) {
      this.renderFileMeta(filesMeta[i]).forEach(input => {
        this.rootEl.appendChild(input);
      });
    }
  }

  detachFileInfoComponent(index, component) {
    const inputs = this.fileInfoComponentEls(index, component);
    inputs.forEach((input) => input.remove());
  }

  fileInfoComponentEls(index, component) {
    if (typeof index !== typeof undefined) {
      return [...this.rootEl
        .querySelectorAll(`.js-file-info--component[data-index="${index}"][data-component="${component}"]`)];
    }

    return [...this.rootEl.querySelectorAll(`.js-file-info--component[data-component="${component}"]:not([data-old-input])`)]
  }

  renderFileMeta({ index = 0, identifier, name, type }) {
    const namePrefix = this.namePrefix();

    const inputPath = document.createElement('input');
    inputPath.dataset.index = index + this.offset;
    inputPath.dataset.component = 'path';
    inputPath.classList.add('js-file-info--component');
    inputPath.type = 'hidden';
    inputPath.name = `${namePrefix}[${index}][old][path]`;
    inputPath.value = identifier;

    const inputOriginalName = document.createElement('input');
    inputOriginalName.dataset.index = index + this.offset;
    inputOriginalName.dataset.component = 'originalName';
    inputOriginalName.classList.add('js-file-info--component');
    inputOriginalName.type = 'hidden';
    inputOriginalName.name = `${namePrefix}[${index}][old][originalName]`;
    inputOriginalName.value = name;

    const inputMimeType = document.createElement('input');
    inputMimeType.dataset.index = index + this.offset
    inputMimeType.dataset.component = 'mimeType';
    inputMimeType.classList.add('js-file-info--component');
    inputMimeType.type = 'hidden';
    inputMimeType.name = `${namePrefix}[${index}][old][mimeType]`;
    inputMimeType.value = type;

    return [inputPath, inputOriginalName, inputMimeType];
  }

  inputEls() {
    return [...this.rootEl.querySelectorAll('input')];
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/uploads/FileInfo.js